const validRoutes = {
  ROOT: "/",
  GROUPS: "groups",
  GROUPS_REQUESTS: "groupsRequests",
  HASHTAGS: "hashtags",
  LOGIN: "login",
  LOGIN_PASSWORD: "loginPassword",
  LOGIN_SSO: "loginSso",
  LOGIN_CODE: "loginCode",
  SIGNUP: "signup",
  EMAIL_CONFIRMATION: "emailConfirmation",
  RESEND_EMAIL_CONFIRMATION: "resendEmailConfirmation",
  POST: "post",
  COMMENT: "comment",
  PAYWALL: "paywall",
  SEARCH: "search",
  EVENT: "event",
  EVENTS: "events",
  FOLDER: "folder",
  ARTICLE: "article",
  PROFILE: "profile",
  PROFILE_BADGE: "profileBadge",
  PROFILE_EDIT: "profileEdit",
  PROFILE_SETTINGS: "profileSettings",
  DELETE_ACCOUNT: "deleteAccount",
  PROFILE_SETTINGS_EMAILS: "emailSettings",
  PROFILE_SETTINGS_LIVESTREAMING: "livestreamingSettings",
  PROFILE_SETTINGS_COOKIES: "cookiesSettings",
  PROFILE_SETTINGS_PUSH_NOTIFICATIONS: "pushNotificationsSettings",
  PROFILE_SETTINGS_NOTIFICATIONS_CENTRE: "notificationsCentreSettings",
  FORGOT_PASSWORD: "forgotPassword",
  INBOX: "inbox",
  MESSAGES: "messages",
  STYLE_GUIDE: "styleGuide",
  LIVE: "live",
  RTMP: "rtmp",
  BROADCAST: "broadcast",
  SCHEDULED_POSTS: "scheduledPosts",
  MEMBER_DIRECTORY: "memberDirectory",
  THIRD_PARTY_SOFTWARE: "thirdPartySoftware",
  WALKTHROUGH: "walkthrough",
  COURSE: "course",
  COURSES: "courses",
  LESSON: "lesson",
  LESSON_MEDIUM_EMBED: "lessonMediumEmbed",
  CHANGE_PASSWORD: "changePassword",
  _404: "404"
}

const routes = new Proxy(validRoutes, {
  get(target, property) {
    if (!target[property]) {
      throw Error(`Route ${property} is invalid!`)
    } else {
      return target[property]
    }
  },
  set() {
    throw Error("Routes are immutable!")
  }
})

export default routes
